import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const AddObjectives = createAsyncThunk(
  "Objectives/AddObjectives",
  async (parameters, { rejectWithValue }) => {
    try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
            "api/SU_NT_WPB_ObjectivesServices/AddObjectives",
            parameters
          );

          const data = response.data.result; // Assuming response has a "data" field
          return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteObjectives = createAsyncThunk(
    "Objectives/DeleteObjectives",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ObjectivesServices/DeleteObjectives",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const GetAllObjective = createAsyncThunk(
    "Objectives/GetAllObjective",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ObjectivesServices/GetAllObjectives",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const EditObjective = createAsyncThunk(
    "Objectives/EditObjective",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ObjectivesServices/EditObjectives",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  export const GetObjective = createAsyncThunk(
    "Objectives/GetObjective",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ObjectivesServices/GetObjectives",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
const ObjectivesReducers = createSlice({
  name: "FetchDataJson",
  initialState: {
    ObjectivesAdd: {},
    loadingObjectivesAdd: false,
    errorObjectivesAdd: null,

    DeleteObjectives: {},
    loadingDeleteObjectives: false,
    errorDeleteObjectives: null,

    ObjectivesList: {},
    loadingObjectivesList: false,
    errorObjectivesList: null,

    Objectives: {},
    loadingObjectives: false,
    errorObjectives: null,

    ObjectivesEdit: {},
    loadingObjectivesEdit: false,
    errorObjectivesEdit: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AddObjectives.pending, (state, action) => {
        state.loadingObjectivesAdd = true;
        state.ObjectivesAdd = action.payload;
        state.errorObjectivesAdd = null;
      })
      .addCase(AddObjectives.fulfilled, (state, action) => {
        state.loadingObjectivesAdd = false;
        state.ObjectivesAdd = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddObjectives.rejected, (state, action) => {
        state.loadingObjectivesAdd = false;
        state.errorObjectivesAdd = action.payload;
      });

      builder
      .addCase(DeleteObjectives.pending, (state, action) => {
        state.loadingDeleteObjectives = true;
        state.DeleteObjectives = action.payload;
        state.errorDeleteObjectives = null;
      })
      .addCase(DeleteObjectives.fulfilled, (state, action) => {
        state.loadingDeleteObjectives = false;
        state.DeleteObjectives = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteObjectives.rejected, (state, action) => {
        state.loadingDeleteObjectives = false;
        state.errorDeleteObjectives = action.payload;
      });

      builder
      .addCase(GetAllObjective.pending, (state, action) => {
        state.loadingObjectivesList = true;
        state.ObjectivesList = action.payload;
        state.errorObjectivesList = null;
      })
      .addCase(GetAllObjective.fulfilled, (state, action) => {
        state.loadingObjectivesList = false;
        state.ObjectivesList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllObjective.rejected, (state, action) => {
        state.loadingObjectivesList = false;
        state.errorObjectivesList = action.payload;
      });
      builder
      .addCase(GetObjective.pending, (state, action) => {
        state.loadingObjectives = true;
        state.Objectives = action.payload;
        state.errorObjectives = null;
      })
      .addCase(GetObjective.fulfilled, (state, action) => {
        state.loadingObjectives = false;
        state.Objectives = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetObjective.rejected, (state, action) => {
        state.loadingObjectives = false;
        state.errorObjectives = action.payload;
      });

      builder
      .addCase(EditObjective.pending, (state, action) => {
        state.loadingObjectivesEdit = true;
        state.ObjectivesEdit = action.payload;
        state.errorObjectivesEdit = null;
      })
      .addCase(EditObjective.fulfilled, (state, action) => {
        state.loadingObjectivesEdit = false;
        state.ObjectivesEdit = action.payload; // Assuming payload has the desired data
      })
      .addCase(EditObjective.rejected, (state, action) => {
        state.loadingObjectivesEdit = false;
        state.errorObjectivesEdit = action.payload;
      });
  },
});






export default ObjectivesReducers.reducer;
